import { QueryClient } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.js';
import { installPopoverExitMotion } from './components/ui/popover-motion.js';
import './i18n/index.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Laboratory data changes through deliberate user actions rather than
      // constantly in the background, so aggressive refetching adds noise
      // without adding accuracy.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// Every dropdown list fades out when it closes (`popover-motion.ts`, D196).
installPopoverExitMotion();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

// `App` owns the router, because the providers underneath it hand the router to
// HeroUI so its links and pressable rows navigate client-side. See Providers.tsx.
createRoot(container).render(
  <StrictMode>
    <App queryClient={queryClient} />
  </StrictMode>,
);
